function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import Spinner from "../../../theme/Spinner";
import { Button } from "reactstrap";
import styled from "styled-components";

class TmSubmitButton extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderButtonText", () => {
      return !!this.props.text ? this.props.text : 'Save';
    });

    _defineProperty(this, "render", () => {
      if (!!this.props.loading) {
        return /*#__PURE__*/React.createElement(Button, _extends({
          color: "primary"
        }, this.props, {
          disabled: true
        }), /*#__PURE__*/React.createElement(Spinner, {
          className: "spinner-grow-sm mr-1",
          tag: "span",
          color: "white",
          type: "grow"
        }), "Saving...");
      } else {
        return /*#__PURE__*/React.createElement(Button, _extends({
          color: "primary",
          type: "submit"
        }, this.props), this.renderButtonText());
      }
    });
  }

}

export default TmSubmitButton;
export const TmRightSubmitButton = styled(TmSubmitButton)`
  float: right;
`;